import { Action, combineReducers, configureStore, ThunkAction } from '@reduxjs/toolkit';
import { demoCredentialSlice, DemoCredentialState, demoCredentialListSlice, DemoCredentialListState, verifySlice, VerifyState, verifyStatusSlice, VerifyStatusState, errorSlice, ErrorState, globalSlice, GlobalState, toastMessageSlice, ToastMessageState, userSlice, UserState, walletSlice, WalletState } from './slices';


export interface ApplicationState {
    globalState: GlobalState;
    userState: UserState;
    toastMessageState: ToastMessageState;
    walletState: WalletState;
    errorState: ErrorState;
    verifyState: VerifyState;
    verifyStatusState: VerifyStatusState;
    demoCredentialState: DemoCredentialState;
    demoCredentialListState: DemoCredentialListState;
}

const rootReducer = combineReducers<ApplicationState>({
    globalState: globalSlice.reducer,
    userState: userSlice.reducer,
    toastMessageState: toastMessageSlice.reducer,
    walletState: walletSlice.reducer,
    errorState: errorSlice.reducer,
    verifyState: verifySlice.reducer,
    verifyStatusState: verifyStatusSlice.reducer,
    demoCredentialState: demoCredentialSlice.reducer,
    demoCredentialListState: demoCredentialListSlice.reducer
});
export const store = configureStore({
    reducer: rootReducer
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>;
